<!-- #region "ownership-amount" -->
<ng-container *ngIf="reportService.showOwnerAmountPage()">
    <div class="row my-2 owner__amount__page" *ngIf="currentReport && currentReport.LATEST">
        <div class="col-md-11">
            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
              <ng-container *ngTemplateOutlet="titleInfo"></ng-container>
            </div>

            <div class="row mt-5">
                <div class="col-md-12">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="label">How many owners does the Company have?</div>
                        <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                    </div>

                    <div class="d-flex">
                        <radio-group-button radioGroupButtonId="ownership-owners-length-type-radio-group"
                            [selectedOption]="selectedOwnerLength" [btnList]="ownerList" [isButton]="false"
                            (optionChange)="selectedOwnerLength = $event; isEnterMore = false;"
                            [(ngModel)]="selectedOwnerLength" #ownerCountSelect="ngModel" name="ownerCountSelect"
                            required [disabled]="currentReport.isLocked">
                        </radio-group-button>

                        <label class="btn btn-white bg-white rounded-0 more" role="button"
                            [class.selected]="isEnterMore"
                            (click)="isEnterMore = !isEnterMore; selectedOwnerLength = null;">
                            <small class="font-weight-bold">Enter more</small>
                        </label>
                    </div>

                    <ng-container *ngIf="isEnterMore">
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="label">Owner Amount</div>
                                <input id="ownership-owner-amount" type="text" numbersOnly
                                    class="input input__large input__blue" [(ngModel)]="selectedOwnerLength" required
                                    #ownerCountInput="ngModel" name="ownerCountInput" [range]="[1, 20]"
                                    placeholder="Please enter the amount of owners" maxlength="2"
                                       [disabled]="currentReport.isLocked">

                                <small *ngIf="ownerCountInput.errors?.range && (ownerCountInput.dirty || ownerCountInput.touched)" class="text-danger">
                                    Please enter value between 1 to 20
                                </small>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>

        </div>
    </div>
</ng-container>
<!-- #endregion -->

<!-- #region "ownership-details" -->
<ng-container *ngIf="!reportService.showOwnerAmountPage()">
    <div class="owner__details__page report__page__with__extra__scroll">
        <div class="row my-2" *ngIf="currentReport && currentReport.LATEST">
          <div class="col-md-12">
            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
              <ng-container *ngTemplateOutlet="titleInfo"></ng-container>
            </div>
          </div>

            <div class="col-md-12 d-flex align-items-center">

                <div role="group" class="group__buttons custom__scroll">
                    <button class="button small__button half-rounded__button mr-2 mb-2"
                        *ngFor="let owner of currentReport.LATEST.OWNERSHIP_LIST; let i = index"
                        id="{{'ownership-select-owner'+i}}"
                        [ngClass]="{'primary__button parent-button': selectedOwner && owner.ID == selectedOwner.ID}"
                        [class.secondary__button]="!selectedOwner || owner.ID != selectedOwner.ID"
                        (click)="selectOwner(owner)">
                        <span class="ellipsis max-width-200">{{reportService.checkStringWithTrim(owner.DISPLAY_NAME) ? owner.DISPLAY_NAME : 'Owner ' + (i + 1)}}</span>
                        <button class="child-button button ghost__button small__button rounded__button"
                            *ngIf="selectedOwner && owner.ID == selectedOwner.ID && i" id="ownership-delete-owner"
                                [disabled]="currentReport.isLocked"
                            (click)="deleteOwner(owner.ID, i)">
                            <img src="../../../../../../assets/images/trash.svg" alt="...">
                        </button>
                    </button>

                    <button *ngIf="currentReport.LATEST.OWNERSHIP_LIST.length < 20"
                        class="button small__button icon__right half-rounded__button blue__bordered__button mr-1 mb-1 add__hover"
                        (click)="addBlankOwner()" id="ownership-add-blank-owner" [disabled]="addOwnerDisabled() || currentReport.isLocked">
                        Add owner <em class="fa fa-plus"></em>
                    </button>

                </div>

            </div>
        </div>

        <form #ownerForm="ngForm" novalidate="novalidate" autocomplete="off">
            <div class="my-5" *ngIf="selectedOwner && selectedOwner.ID">
                <div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Owner Name</div>
                                <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                            </div>

                            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                                Optionally, you can enter the owner's name (typically located on the K1 or 1125-E).
                            </div>

                            <input type="text" id="ownership-selected-owner" class="input input__large input__blue"
                                placeholder="e.g.: Bill Murray" [ngModel]="selectedOwner.DISPLAY_NAME ? selectedOwner.DISPLAY_NAME : selectedOwner.NAME"
                                (ngModelChange)="selectedOwner.DISPLAY_NAME = $event" [maxlength]="100"
                                [disabled]="currentReport.isLocked" (focus)="focusOwnerName()"
                                (blur)="makeDefaultName()">
                        </div>

                    </div>

                    <div class="row mt-4">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Percent of Company Owned</div>
                                <div class="color--light--gray font-size-14 font-weight-bold">Optional</div>
                            </div>

                            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                                Please enter the percentage (1 – 100) of Company ownership for this owner. Total for all
                                owners
                                must equal
                                100.
                            </div>

                            <div>
                                <input id="ownership-check-percentage" percentageOnly type="text"
                                    class="input input__large input__blue" placeholder="e.g.: 30"
                                    [(ngModel)]="selectedOwner.PERCENT" [disabled]="currentReport.isLocked"
                                    (blur)="PERCENT.valid && checkPercentage() ? callUpdateAPI('PERCENT') : selectedOwner.PERCENT = null"
                                    [range]="[0.001, 100]" #PERCENT="ngModel" name="PERCENT"
                                    (keyup.enter)="PERCENT.valid && checkPercentage() ? callUpdateAPI('PERCENT') : null">

                                <small *ngIf="PERCENT.errors?.range && (PERCENT.dirty || PERCENT.touched)"
                                    class="text-danger">
                                    percentage from 1 to 100
                                </small>
                            </div>

                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-md-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="label">Number of Hours Worked Per Week</div>
                                <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
                            </div>

                            <div class="color-secondary-gray font-size-14 font-weight-normal mb-3">
                                Please enter the number of hours per week each owner works at the Company. Enter “0” for
                                absentee owners.
                                Enter "40" for full-time owner operators.
                            </div>

                            <div>
                                <input numbersOnly appRemoveLeadingZero id="ownership-working-hours" type="text"
                                    class="input input__large input__blue" placeholder="e.g.: 40" [range]="[0, 168]"
                                    #HOURS="ngModel" name="HOURS" [(ngModel)]="selectedOwner.HOURS"
                                    [disabled]="currentReport.isLocked"
                                    (blur)="HOURS.valid ? callUpdateAPI('HOURS') : selectedOwner.HOURS = null" required
                                    (keyup.enter)="HOURS.valid ? callUpdateAPI('HOURS') : null" maxlength="3">

                                <small *ngIf="HOURS.errors?.range && (HOURS.dirty || HOURS.touched)"
                                    class="text-danger">
                                    Owner cannot work more than 168 hours per week
                                </small>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </form>
    </div>
</ng-container>
<!-- #endregion -->

<report-footer (buttonClicked)="footerButtonClick($event)"
    [nextBtnEnable]="(reportService.showOwnerAmountPage() && selectedOwnerLength && selectedOwnerLength > 0 && selectedOwnerLength <= 20) || (ownerForm && !ownerForm.invalid)"
    [pageId]="reportPageConst.OWNERSHIP">
</report-footer>

<ng-template #titleInfo>
  Please provide information regarding the Company’s ownership structure.<br />
  Only include individuals with ownership, stock shares, or membership units in the Company.<br />
  To find ownership information on your tax return click <span class="cursor-pointer color--blue" (click)="openTaxReturnInfoModel()">here</span>.
</ng-template>
